import TyDatetimePicker from './TyDatetimePicker.vue'
export default TyDatetimePicker



// WEBPACK FOOTER //
// ./src/components/ty-datetime-picker/index.js